export const environment = {
  production: true,
  S2EMULATOR_API_ENDPOINT: (window as any)['env']['S2EMULATOR_API_ENDPOINT'] || 'https://localhost:8081/api/v1',
  BASE_S2EMULATOR_API_ENDPOINT: (window as any)['env']['BASE_S2EMULATOR_API_ENDPOINT'] || 'https://localhost:8081',
  USER_KEY: (window as any)['env']['USER_KEY'] || 's2emulator_user',
  USER_KEY_IAM: (window as any)['env']['USER_KEY_IAM'] || '0-emulator-ui',
  baseHRef: (window as any)['env']['baseHRef'] || '/emu/ui/',
  AUTH_AUTHORITY: (window as any)['env']['AUTH_AUTHORITY'] || 'https://api-dev.s2auth.com/realms/s2-emulator',
  AUTH_AUTHORITY_API: (window as any)['env']['AUTH_AUTHORITY_API'] || 'https://api-dev.s2auth.com/admin/realms/s2-emulator',
  AUTH_CLIENT_ID: (window as any)['env']['AUTH_CLIENT_ID'] || 'emulator-ui'
};